/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from "prop-types";
import React from "react";

// import styling of the component:
import { Container, StyledInput, Icon } from "./LineInput.style";

const LineInput = ({
  name,
  label,
  icon,
  type,
  value,
  customStyle,
  onChange,
  inputStyle,
}) => {
  return (
    <Container main {...customStyle}>
      <Container {...customStyle}>
        <StyledInput
          name={name}
          label={label}
          placeholder={label}
          type={type}
          onChange={onChange}
          value={value}
          style={inputStyle}
        />
        <Icon>{icon}</Icon>
      </Container>
    </Container>
  );
};

LineInput.defaultProps = {
  icon: null,
  customStyle: {},
  value: "",
  onChange: null,
  inputStyle: {},
};

LineInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.element,
  type: PropTypes.string.isRequired,
  customStyle: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func,
  inputStyle: PropTypes.object,
};

export default LineInput;
